
import BookingExtraCheckbox from "@/components/bookingflow/steps/extras/BookingExtraCheckbox.vue";
import { DirectionEnum } from "@/models/enums";
import { ExtraInnerSection } from "@/models/www/ExtrasComponent";
import { defineComponent, PropType } from "vue";

export default defineComponent ({
	components: {
		BookingExtraCheckbox
	},
	props: {
		section: {
			type: Object as PropType<ExtraInnerSection>
		},
		direction: {
			type: Number as PropType<DirectionEnum>,
			required: true
		}
	}
})
